module.exports = __webpack_public_path__ + "img/logo.01340539.png";